import { PublicClientApplication } from '@azure/msal-browser';

const CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID;
const AUTHORITY = import.meta.env.VITE_AZURE_AUTHORITY;
const REDIRECT = import.meta.env.VITE_AZURE_REDIRECT_URI;

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId:   CLIENT_ID,
    authority:  AUTHORITY,
    redirectUri: REDIRECT,
    navigateToLoginRequestUrl: false
  },
  cache: { 
    cacheLocation: 'localStorage', 
    storeAuthStateInCookie: false 
  },
  system: {
    iframeHashTimeout: 2000,
    loadFrameTimeout: 2000,
    windowHashTimeout: 2000
  }
});

export function initializeMsal() {
  return msalInstance.initialize();
}
